import { Input, InputProps } from "@chakra-ui/react";
import { NumericFormat, NumberFormatValues, SourceInfo } from "react-number-format";

interface NumericInputProps extends Omit<InputProps, "type" | "value" | "onChange" | "defaultValue"> {
  numericValue: number | null;
  onNumericChange: (value: number | null) => void;
}

export const NumericInput = ({ numericValue, onNumericChange, ...rest }: NumericInputProps) => {
  const handleValueChange = (values: NumberFormatValues, sourceInfo: SourceInfo) => {
    if (sourceInfo.source !== "event") return;
    onNumericChange(values.floatValue ?? null);
  };

  // react-number-format needs a text input to render thousand separators, which makes the browser
  // treat it as a free-text field and offer autofill suggestions from unrelated history.
  return (
    <NumericFormat
      customInput={Input}
      thousandSeparator={"\u00A0"}
      allowNegative={false}
      value={numericValue ?? ""}
      onValueChange={handleValueChange}
      autoComplete="off"
      inputMode="decimal"
      rounded="md"
      {...rest}
    />
  );
};
